import React, { useState, useEffect } from 'react';
import Styles from './BrokerageCalculator.module.css';
import {
    Typography, Grid2, Radio, RadioGroup, FormControlLabel, TextField
} from '@mui/material';
import { withStyles, styled } from "@mui/styles";
import en from "../../../i18n/English/Home/cal.json"
import hi from "../../../i18n/Hindi/Home/cal.json";
import kn from "../../../i18n/Kannada/Home/cal.json"
import ma from "../../../i18n/Marathi/Home/cal.json";
import gu from "../../../i18n/Gujarati/Home/cal.json"
import { useLanguage } from '../../../Context/LangContext';
const styles = theme => ({
    bmaintit: {
        color: '#3E3E3E',
        fontFamily: 'cardiuma-Bold !important',
        fontSize: "calc(32px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: 'normal',
    },
    maincard: {
        width: '100%',
        justifyContent: 'center',
        display: 'flex',
        padding: '100px 0px 0px 0px',
    },
    subcard: {
        width: '23%',
        padding: '24px',
        borderRadius: '8px',
        background: '#ffffff',
        "@media only screen and (max-device-width: 950px)": {
            width: '100%',
            marginTop: "15px !important"
        }
    },
    subcard1: {
        width: '40%',
        padding: '24px',
        borderRadius: '8px',
        background: '#ffffff',
    },
    subcard2: {
        width: '45%',
        padding: '24px',
        borderRadius: '8px',
        background: '#ffffff',
    },
    subtit: {
        color: '#3E3E3E',
        fontFamily: 'Inter500',
        fontSize: "calc(16px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '18px',
    },
    subtit1: {
        color: '#2F2F2F',
        fontFamily: 'Inter400 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '20px',
    },
    bamountcard: {
        borderRadius: '4px',
        border: '1px solid #999999',
        background: '#FFFFFF',
        padding: '6px',
        display: 'flex',
        height: '32px',
        justifyContent: 'flex-start',
    },
    bamount: {
        color: '#3E3E3E',
        fontFamily: 'cardiuma-regular !important',
        fontSize: "calc(12px + var(--font-delta)) !important",
        fontStyle: 'normal',
        textAlign: 'left',
        fontWeight: '400',
    },
    bopttxt: {
        color: '#3E3E3E',
        fontFamily: 'Inter500 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '20px',
    },
    bsubtit1: {
        color: '#3E3E3E',
        fontFamily: 'Inter400 !important',
        fontSize: "calc(12px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '32px',
    },
    bsubtit2: {
        color: '#3E3E3E',
        fontFamily: 'Inter400 !important',
        fontSize: "calc(12px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '32px',
        textAlign: 'right',
    },
    nettit: {
        color: '#3E3E3E',
        fontFamily: 'Inter700 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px',
    },
    netamt: {
        color: '#15803D',
        fontFamily: 'Inter700 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px',
    },
    netamt1: {
        color: '#F74542',
        fontFamily: 'Inter700 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px',
    },
    card: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around',
        marginBottom: '50px',
        "@media only screen and (max-device-width: 950px)": {
            width: '100%',
            display: 'block',
            justifyContent: 'center',

        }
    }
});

const CssTextField = styled(TextField)({
    borderRadius: '8px',
    '& label.Mui-focused': {
        color: '#999999',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: '#999999',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#999999',
        },
        '&:hover fieldset': {
            borderColor: '#999999',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#999999',
        },
    },
});

const FandO = ({ classes }) => {

    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language];
    const [state, setState] = useState({
        // Input fields
        b1: 1000, s1: 1100, q1: 400, opt1: "nse1",
        b2: 1000, s2: 1100, q2: 400, opt2: "nse2",
        b3: 1000, s3: 1100, q3: 400, opt3: "nse3",
        b4: 100, s4: 110, q4: 400, opt4: "nse4",

        // Calculated fields (Intraday Equity)
        turnover1: 0, brokerage_buy1: 0, stt_total1: 0, exc_trans_charge1: 0,
        gst1: 0, sebi_charges1: 0, stamp_charges1: 0, total_tax1: 0,
        breakeven1: 0, net_profit1: 0,

        // Calculated fields (Delivery Equity)
        turnover2: 0, brokerage_buy2: 0, stt_total2: 0, exc_trans_charge2: 0,
        gst2: 0, sebi_charges2: 0, stamp_charges2: 0, dp: 0, total_tax2: 0,
        breakeven2: 0, net_profit2: 0,

        // Calculated fields (Futures)
        turnover3: 0, brokerage_buy3: 0, stt_total3: 0, exc_trans_charge3: 0,
        gst3: 0, sebi_charges3: 0, stamp_charges3: 0, total_tax3: 0,
        breakeven3: 0, net_profit3: 0,

        // Calculated fields (Options)
        turnover4: 0, brokerage_buy4: 0, stt_total4: 0, exc_trans_charge4: 0,
        gst4: 0, sebi_charges4: 0, stamp_charges4: 0, total_tax4: 0,
        breakeven4: 0, net_profit4: 0,
    });


    useEffect(() => {
        initialRender()
    }, [state.b1, state.b2, state.b3, state.b4, state.s1, state.s2, state.s3, state.s4, state.q1, state.q2, state.q3, state.q4, state.opt1, state.opt2, state.opt3, state.opt4])



    console.log("state",state)

    const handle1 = (e) => {
        const selectedValue = e.target.value; // "nse4" or "bse4"

        // Update the state with the selected value
        setState((prevState) => ({
            ...prevState,
            opt1: selectedValue,
        }));
    };

    const handle2 = (e) => {
        const selectedValue = e.target.value;


        setState((prevState) => ({
            ...prevState,
            opt2: selectedValue,
        }));
    };

    const handle3 = (e) => {
        const selectedValue = e.target.value;


        setState((prevState) => ({
            ...prevState,
            opt3: selectedValue,
        }));
    };


    const handle4 = (e) => {
        const selectedValue = e.target.value;


        setState((prevState) => ({
            ...prevState,
            opt4: selectedValue,
        }));
    };


    const eb1 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.b1 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.b1 = newValue;
            }
        }
        setState(updatedState);

    };

    const es1 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.s1 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.s1 = newValue;
            }
        }
        setState(updatedState);

    };

    const eq1 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.q1 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.q1 = newValue;
            }
        }
        setState(updatedState);
    };


    const eb2 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.b2 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.b2 = newValue;
            }
        }
        setState(updatedState);
    };

    const es2 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.s2 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.s2 = newValue;
            }
        }
        setState(updatedState);
    };

    const eq2 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.q2 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.q2 = newValue;
            }
        }
        setState(updatedState);

    };

    const eb3 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };
        if (inputValue === '') {
            updatedState.b3 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.b3 = newValue;
            }
        }
        setState(updatedState);
    };

    const es3 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.s3 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.s3 = newValue;
            }
        }
        setState(updatedState);

    };

    const eq3 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.q3 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.q3 = newValue;
            }
        }
        setState(updatedState);

    };

    const eb4 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state };

        if (inputValue === '') {
            updatedState.b4 = '';
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.b4 = newValue; // Update q1 in the local state
            }
        }
        setState(updatedState);

    };

    const es4 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state }; // Create a local copy of the state

        if (inputValue === '') {
            updatedState.s4 = ''; // Set to empty if input is empty
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.s4 = newValue; // Update q1 in the local state
            }
        }
        setState(updatedState);

    };

    const eq4 = (e) => {
        const inputValue = e.target.value;

        let updatedState = { ...state }; // Create a local copy of the state

        if (inputValue === '') {
            updatedState.q4 = ''; // Set to empty if input is empty
        } else {
            const newValue = parseInt(inputValue);
            if (!isNaN(newValue)) {
                updatedState.q4 = newValue; // Update q1 in the local state
            }
        }
        setState(updatedState);

    };



    const initialRender =()=>{


        //intraday
        let { b1, s1, q1, opt1 } = state;

        console.log("equity", b1)
        let turnover1 = parseFloat(b1) + parseFloat(s1);
        let brokerage_buy1 = ((b1 * q1 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(b1 * q1 * 0.0003).toFixed(2));
        let brokerage_sell1 = ((s1 * q1 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(s1 * q1 * 0.0003).toFixed(2));
        let brokerage1 = (parseFloat(brokerage_buy1) + parseFloat(brokerage_sell1)).toFixed(2);
        turnover1 = (parseFloat(turnover1) * parseFloat(q1)).toFixed(2);
        let exc_trans_charge1 = 0;
        let nse_ipft1 = 0;

        if (opt1 === "nse1") {
            exc_trans_charge1 = parseFloat(parseFloat(0.0000325 * turnover1).toFixed(2));
            nse_ipft1 = parseFloat(parseFloat(0.000001 * turnover1).toFixed(2));
        } else {
            exc_trans_charge1 = parseFloat(parseFloat(0.0000375 * turnover1).toFixed(2));
            nse_ipft1 = 0;
        }

        let stt_total1 = Math.round(parseFloat(parseFloat((s1 * q1) * 0.00025).toFixed(2)));
        let sebi_charges1 = parseFloat(parseFloat(turnover1 * 0.000001).toFixed(2));
        let gst1 = ((parseFloat(brokerage1) + parseFloat(exc_trans_charge1) + parseFloat(sebi_charges1)) * 0.18).toFixed(2);
        exc_trans_charge1 = (exc_trans_charge1 + nse_ipft1).toFixed(2);
        let stamp_charges1 = Math.round(parseFloat(parseFloat((b1 * q1) * 0.00003).toFixed(2)));
        let total_tax1 = parseFloat(brokerage1) + parseFloat(stt_total1) + parseFloat(exc_trans_charge1) + parseFloat(gst1) + parseFloat(sebi_charges1) + parseFloat(stamp_charges1);
        let breakeven1 = parseFloat(parseFloat(total_tax1 / q1).toFixed(2));
        breakeven1 = isNaN(breakeven1) ? 0 : breakeven1;
        let net_profit1 = parseFloat(parseFloat(((s1 - b1) * q1) - total_tax1).toFixed(2));




        //delivery
        let { b2, s2, q2, opt2 } = state;
        console.log("delivery")
        let turnover2 = parseFloat(b2) + parseFloat(s2);
        let brokerage_buy2 = ((b2 * q2 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(b2 * q2 * 0.0003).toFixed(2));
        let brokerage_sell2 = ((s2 * q2 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(s2 * q2 * 0.0003).toFixed(2));
        let brokerage2 = 0;
        turnover2 = (parseFloat(turnover2) * parseFloat(q2)).toFixed(2);
        let stt_total2 = Math.round(parseFloat(parseFloat(turnover2 * 0.001).toFixed(2)));
        let sebi_charges2 = parseFloat(parseFloat(turnover2 * 0.000001).toFixed(2));
        let exc_trans_charge2 = 0;
        let nse_ipft2 = 0;

        if (opt2 === "nse2") {
            exc_trans_charge2 = parseFloat(parseFloat(0.0000325 * turnover2).toFixed(2));
            nse_ipft2 = parseFloat(parseFloat(0.000001 * turnover2).toFixed(2));
        } else {
            exc_trans_charge2 = parseFloat(parseFloat(0.0000375 * turnover2).toFixed(2));
            nse_ipft2 = 0;
        }

        let dp2 = s2 === 0 ? 0 : 15.93;
        let gst2 = ((parseFloat(brokerage2) + parseFloat(exc_trans_charge2) + parseFloat(sebi_charges2)) * 0.18).toFixed(2);
        exc_trans_charge2 = (exc_trans_charge2 + nse_ipft2).toFixed(2);
        let stamp_charges2 = Math.round(parseFloat(parseFloat(b2 * q2 * 0.00015).toFixed(2)));
        let total_tax2 = (parseFloat(brokerage2) + parseFloat(stt_total2) + parseFloat(exc_trans_charge2) + parseFloat(dp2) + parseFloat(gst2) + parseFloat(sebi_charges2) + parseFloat(stamp_charges2)).toFixed(2);
        let breakeven2 = parseFloat(parseFloat(total_tax2 / q2).toFixed(2));
        breakeven2 = isNaN(breakeven2) ? 0 : breakeven2;
        let net_profit2 = parseFloat(parseFloat(((s2 - b2) * q2) - total_tax2).toFixed(2));



        //future

        let { b3, s3, q3, opt3 } = state;
        console.log("future")
        let turnover3 = parseFloat(b3) + parseFloat(s3);
        let brokerage_buy3 = ((b3 * q3 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(b3 * q3 * 0.0003).toFixed(2));
        let brokerage_sell3 = ((s3 * q3 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(s3 * q3 * 0.0003).toFixed(2));
        let brokerage3 = (parseFloat(brokerage_buy3) + parseFloat(brokerage_sell3)).toFixed(2);
        turnover3 = (parseFloat(turnover3) * parseFloat(q3)).toFixed(2);
        let stt_total3 = Math.round(parseFloat(parseFloat(s3 * q3 * 0.000125).toFixed(2)));
        let sebi_charges3 = parseFloat(parseFloat(turnover3 * 0.000001).toFixed(2));
        let exc_trans_charge3 = 0;
        let nse_ipft3 = 0;

        if (opt3 === "nse3") {
            exc_trans_charge3 = parseFloat(parseFloat(0.000019 * turnover3).toFixed(2));
            nse_ipft3 = parseFloat(parseFloat(0.000001 * turnover3).toFixed(2));
        } else {
            exc_trans_charge3 = 0;
            nse_ipft3 = 0;
        }

        let gst3 = ((parseFloat(brokerage3) + parseFloat(exc_trans_charge3) + parseFloat(sebi_charges3)) * 0.18).toFixed(2);
        exc_trans_charge3 = (exc_trans_charge3 + nse_ipft3).toFixed(2);
        let stamp_charges3 = Math.round(parseFloat(parseFloat(b3 * q3 * 0.00002).toFixed(2)));
        let total_tax3 = (parseFloat(brokerage3) + parseFloat(stt_total3) + parseFloat(exc_trans_charge3) + parseFloat(gst3) + parseFloat(sebi_charges3) + parseFloat(stamp_charges3)).toFixed(2);
        let breakeven3 = parseFloat(parseFloat(total_tax3 / q3).toFixed(2));
        breakeven3 = isNaN(breakeven3) ? 0 : breakeven3;
        let net_profit3 = parseFloat(parseFloat(((s3 - b3) * q3) - total_tax3).toFixed(2));




        //options
        let { b4, s4, q4, opt4 } = state;
        console.log("options")
        let turnover4 = parseFloat(b4) + parseFloat(s4);
        let brokerage_buy4 = ((b4 * q4 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(b4 * q4 * 0.0003).toFixed(2));
        let brokerage_sell4 = ((s4 * q4 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(s4 * q4 * 0.0003).toFixed(2));
        let brokerage4 = 40;
        turnover4 = (parseFloat(turnover4) * parseFloat(q4)).toFixed(2);
        let stt_total4 = Math.round(parseFloat(parseFloat(s4 * q4 * 0.000625).toFixed(2)));
        let sebi_charges4 = parseFloat(parseFloat(turnover4 * 0.000001).toFixed(2));
        let exc_trans_charge4 = 0;
        let nse_ipft4 = 0;

        if (opt4 === "nse4") {
            exc_trans_charge4 = parseFloat(parseFloat(0.0005 * turnover4).toFixed(2));
            nse_ipft4 = parseFloat(parseFloat(0.000005 * turnover4).toFixed(2));
        } else {
            exc_trans_charge4= parseFloat(parseFloat(0.00005 * turnover4).toFixed(2));
            nse_ipft4 = 0;
        }

        let gst4 = ((parseFloat(brokerage4) + parseFloat(exc_trans_charge4) + parseFloat(sebi_charges4)) * 0.18).toFixed(2);
        exc_trans_charge4 = (exc_trans_charge4 + nse_ipft4).toFixed(2);
        let stamp_charges4 = Math.round(parseFloat(parseFloat(b4 * q4 * 0.00002).toFixed(2)));
        let total_tax4 = (parseFloat(brokerage4) + parseFloat(stt_total4) + parseFloat(exc_trans_charge4) + parseFloat(gst4) + parseFloat(sebi_charges4) + parseFloat(stamp_charges4)).toFixed(2);
        let breakeven4 = parseFloat(parseFloat(total_tax4 / q4).toFixed(2));
        breakeven4 = isNaN(breakeven4) ? 0 : breakeven4;
        let net_profit4 = parseFloat(parseFloat(((s4 - b4) * q4) - total_tax4).toFixed(2));


        console.log("inital", {
            brokerage_buy1: brokerage1,
            turnover1: turnover1,
            stt_total1: stt_total1,
            sebi_charges1: sebi_charges1,
            exc_trans_charge1: exc_trans_charge1,
            gst1: gst1,
            stamp_charges1: stamp_charges1,
            total_tax1: total_tax1,
            breakeven1: breakeven1,
            net_profit1: net_profit1,


            brokerage_buy2: brokerage2,
            turnover2: turnover2,
            stt_total2: stt_total2,
            sebi_charges2: sebi_charges2,
            exc_trans_charge2: exc_trans_charge2,
            dp: dp2,
            gst2: gst2,
            stamp_charges2: stamp_charges2,
            total_tax2: total_tax2,
            breakeven2: breakeven2,
            net_profit2: net_profit2,



            exc_trans_charge3: exc_trans_charge3,
            gst3: gst3,
            brokerage_buy3: brokerage3,
            turnover3: turnover3,
            stt_total3: stt_total3,
            sebi_charges3: sebi_charges3,
            stamp_charges3: stamp_charges3,
            total_tax3: total_tax3,
            breakeven3: breakeven3,
            net_profit3: net_profit3,


            exc_trans_charge4: exc_trans_charge4,
            gst4: gst4,
            brokerage_buy4: brokerage4,
            turnover4: turnover4,
            stt_total4: stt_total4,
            sebi_charges4: sebi_charges4,
            stamp_charges4: stamp_charges4,
            total_tax4: total_tax4,
            breakeven4: breakeven4,
            net_profit4: net_profit4
})

        setState(prev => ({
            ...prev, // Preserve existing state
            brokerage_buy1: brokerage1,
            turnover1: turnover1,
            stt_total1: stt_total1,
            sebi_charges1: sebi_charges1,
            exc_trans_charge1: exc_trans_charge1,
            gst1: gst1,
            stamp_charges1: stamp_charges1,
            total_tax1: total_tax1,
            breakeven1: breakeven1,
            net_profit1: net_profit1,


            brokerage_buy2: brokerage2,
            turnover2: turnover2,
            stt_total2: stt_total2,
            sebi_charges2: sebi_charges2,
            exc_trans_charge2: exc_trans_charge2,
            dp: dp2,
            gst2: gst2,
            stamp_charges2: stamp_charges2,
            total_tax2: total_tax2,
            breakeven2: breakeven2,
            net_profit2: net_profit2,



            exc_trans_charge3: exc_trans_charge3,
            gst3: gst3,
            brokerage_buy3: brokerage3,
            turnover3: turnover3,
            stt_total3: stt_total3,
            sebi_charges3: sebi_charges3,
            stamp_charges3: stamp_charges3,
            total_tax3: total_tax3,
            breakeven3: breakeven3,
            net_profit3: net_profit3,


            exc_trans_charge4: exc_trans_charge4,
            gst4: gst4,
            brokerage_buy4: brokerage4,
            turnover4: turnover4,
            stt_total4: stt_total4,
            sebi_charges4: sebi_charges4,
            stamp_charges4: stamp_charges4,
            total_tax4: total_tax4,
            breakeven4: breakeven4,
            net_profit4: net_profit4

        }));

    }

    console.log("state",state)

    return (
        <div className={classes.card}>
            <Grid2 className={classes.subcard}>
                <Typography className={classes.subtit}>{t.intradayEquity}</Typography>
                <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.buy}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.sell}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.quantity}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.b1}
                            name="buy"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "BUY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={eb1}
                        />
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.s1}
                            name="sell"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "SELL",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={es1}
                        />
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.q1}
                            name="quantity"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "QUANTITY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={eq1}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '10px', justifyContent: 'center' }}>
                    <RadioGroup
                        row
                        value={state.opt1}
                        onChange={handle1}
                    >
                        <FormControlLabel value="nse1" control={<Radio
                            disableRipple
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.nse}</Typography>} />
                        <FormControlLabel value="bse1" control={<Radio
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.bse}</Typography>} />
                    </RadioGroup>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.turnover}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.turnover1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.brokerage}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.subtit1}>{state.brokerage_buy1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.sttTotal}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stt_total1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.exchangeTxnCharge}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.exc_trans_charge1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.clearingCharge}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>0</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.gst}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.gst1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.sebiCharges}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.sebi_charges1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.stampDuty}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stamp_charges1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.totalTaxCharges}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.total_tax1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.pointsBreakeven}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.breakeven1}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '30px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.nettit} style={{fontWeight:700}}>{t.netPL}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={state.net_profit1 > 0 ? classes.netamt : classes.netamt1}>{state.net_profit1}</Typography>
                    </Grid2>
                </Grid2>
            </Grid2>
            <Grid2 className={classes.subcard}>
                <Typography className={classes.subtit}>{t.deliveryEquity}</Typography>
                <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.buy}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.sell}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.quantity}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.b2}
                            name="buy"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "BUY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={eb2}
                        />
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.s2}
                            name="sell"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "SELL",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={es2}
                        />
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.q2}
                            name="quantity"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "QUANTITY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={eq2}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '10px', justifyContent: 'center' }}>
                    <RadioGroup
                        row
                        value={state.opt2}
                        onChange={handle2}
                    >
                        <FormControlLabel value="nse2" control={<Radio
                            disableRipple
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.nse}</Typography>} />
                        <FormControlLabel value="bse2" control={<Radio
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.bse}</Typography>} />
                    </RadioGroup>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.turnover}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.turnover2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.brokerage}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.brokerage_buy2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.sttTotal}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stt_total2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.exchangeTxnCharge}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.exc_trans_charge2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.dpCharge}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.dp}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.gst}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.gst2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.sebiCharges}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.sebi_charges2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.stampDuty}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stamp_charges2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.totalTaxCharges}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.total_tax2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.pointsBreakeven}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.breakeven2}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '30px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.nettit} style={{fontWeight:700}}>{t.netPL}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={state.net_profit2 > 0 ? classes.netamt : classes.netamt1}>{state.net_profit2}</Typography>
                    </Grid2>
                </Grid2>
            </Grid2>
            <Grid2 className={classes.subcard}>
                <Typography className={classes.subtit}>{t.foFutures}</Typography>
                <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.buy}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.sell}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.quantity}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.b3}
                            name="buy"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "BUY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={eb3}
                        />
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.s3}
                            name="sell"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "SELL",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={es3}
                        />
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.q3}
                            name="quantity"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "QUANTITY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={eq3}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '10px', justifyContent: 'center' }}>
                    <RadioGroup
                        row
                        value={state.opt3}
                        onChange={handle3}
                    >
                        <FormControlLabel value="nse3" control={<Radio
                            disableRipple
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.nse}</Typography>} />
                        <FormControlLabel value="bse3" control={<Radio
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.bse}</Typography>} />
                    </RadioGroup>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.turnover}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.turnover3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.brokerage}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.brokerage_buy3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.sttTotal}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stt_total3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.exchangeTxnCharge}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.exc_trans_charge3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.clearingCharge}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>0</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.gst}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.gst3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.sebiCharges}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.sebi_charges3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.stampDuty}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stamp_charges3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.totalTaxCharges}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.total_tax3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.pointsBreakeven}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.breakeven3}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '30px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.nettit} style={{fontWeight:700}}>{t.netPL}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={state.net_profit3 > 0 ? classes.netamt : classes.netamt1}>{state.net_profit3}</Typography>
                    </Grid2>
                </Grid2>
            </Grid2>
            <Grid2 className={classes.subcard}>
                <Typography className={classes.subtit}>{t.foOptions}</Typography>
                <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.buy}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.sell}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>{t.quantity}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.b4}
                            name="buy"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "BUY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={eb4}
                        />
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.s4}
                            name="sell"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "SELL",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={es4}
                        />
                    </Grid2>
                    <Grid2 style={{ width: '30%' }}>
                        <CssTextField
                            value={state.q4}
                            name="quantity"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "QUANTITY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#2F2F2F',
                                },
                            }}
                            onChange={eq4}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '10px', justifyContent: 'center' }}>
                    <RadioGroup
                        row
                        value={state.opt4}
                        onChange={handle4}
                    >
                        <FormControlLabel value="nse4" control={<Radio
                            disableRipple
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.nse}</Typography>} />
                        <FormControlLabel value="bse4" control={<Radio
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path': {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.bse}</Typography>} />
                    </RadioGroup>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.turnover}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.turnover4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.brokerage}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.brokerage_buy4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.sttTotal}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stt_total4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.exchangeTxnCharge}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.exc_trans_charge4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.clearingCharge}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>0</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.gst}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.gst4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.sebiCharges}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.sebi_charges4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.stampDuty}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stamp_charges4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.totalTaxCharges}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.total_tax4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.pointsBreakeven}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.breakeven4}</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 style={{ width: '100%', display: 'flex', marginTop: '30px' }}>
                    <Grid2 style={{ width: '60%' }}>
                        <Typography className={classes.nettit} style={{fontWeight:700}}>{t.netPL}</Typography>
                    </Grid2>
                    <Grid2 style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={state.net_profit4 > 0 ? classes.netamt : classes.netamt1}>{state.net_profit4}</Typography>
                    </Grid2>
                </Grid2>
            </Grid2>
        </div>
    );
};

export default withStyles(styles)(FandO);
